import React, { useState } from "react";
import { FooterLiAmais, InternalLink } from "../Footer/Footer";
import styled from "styled-components";

import ChevronDown from '../../assets/img/chevron-down.svg'

import ChevronUp from '../../assets/img/chevron-up.svg'

const SubMenuUl = styled.ul`
    padding: 0;
    margin: 10px 0 10px 1rem; 
    display: flex;
    flex-direction: column;
    gap: 6px;
    border-left: 2px solid #009EDB;
    padding-left: 10px;
`;

const ExpandableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;


const ExpandableFooterItem = ({ label, items }) => {
  const [open, setOpen] = useState(false);

  
  return (
    <ExpandableContainer>
      <FooterLiAmais>
        <div
          onClick={() => setOpen(!open)}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "white"
          }}
        >
          {label}
          <span>{open ? <img src={ChevronDown} /> : <img src={ChevronUp} />}</span>
        </div>
      </FooterLiAmais>

      {open && (
        <SubMenuUl>
          {items.map((item, i) => (
            <FooterLiAmais key={i}>
              <InternalLink to={item.link}>{item.label}</InternalLink>
            </FooterLiAmais>
          ))}
        </SubMenuUl>
      )}
    </ExpandableContainer>
  );
};

export default ExpandableFooterItem;
